import { createBrowserClient } from '@supabase/ssr';

import type { Database } from '@archetelos/db';

const url = import.meta.env.PUBLIC_SUPABASE_URL;
const anonKey = import.meta.env.PUBLIC_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'PUBLIC_SUPABASE_URL and PUBLIC_SUPABASE_ANON_KEY must be set in apps/app/.env.local',
  );
}

// Phase H: sessions live in cookies (not localStorage) so the marketing site at
// archetelos.stream and the app at app.archetelos.stream share one login.
// @supabase/ssr 0.10.3 fixed the 0.5.x generic-collapse bug, so the Database
// type binding survives through .from()/.rpc() — Option A is viable.
//
// In production the cookie is scoped to the registrable domain so every
// subdomain sees it. Locally `domain` is left undefined (host-only cookie on
// localhost) and `secure` is off so dev over http still works. `sameSite: lax`
// keeps the cookie on top-level cross-subdomain navigation while still blocking
// it from third-party POSTs. Edge Function calls are unaffected: supabase-js
// still attaches the access token as an Authorization bearer header.
export const supabase = createBrowserClient<Database>(url, anonKey, {
  cookieOptions: {
    domain: import.meta.env.PROD ? '.archetelos.stream' : undefined,
    sameSite: 'lax',
    secure: import.meta.env.PROD,
    path: '/',
  },
});
